import React from 'react';
import CustomLineChart from '../../common/CustomLineChart';
import { STORY_UI } from '../../solution-stories/storyUiTokens';
import { SEARCE_COLORS } from '../../../theme';
import { formatUsdCompact, type MonthlyTrendPoint } from '../../../utils/billingReportMetrics';

export interface BillingReportTrendChartProps {
  data: MonthlyTrendPoint[];
}

export function BillingReportTrendChart({ data }: BillingReportTrendChartProps): React.ReactElement {
  return (
    <CustomLineChart
      data={data}
      xAxisDataKey="month"
      yAxisTickFormatter={(v) => formatUsdCompact(Number(v))}
      height={300}
      showCard={false}
      showLegend
      lines={[
        { dataKey: 'budget', label: 'Budget', color: STORY_UI.accent, strokeDasharray: '4 4', dotRadius: 0 },
        { dataKey: 'spend', label: 'Spend', color: SEARCE_COLORS.secondary, strokeWidth: 2.5 },
      ]}
      tooltipFields={[
        { dataKey: 'budget', label: 'Budget', formatter: (v) => formatUsdCompact(Number(v)) },
        { dataKey: 'spend', label: 'Spend', formatter: (v) => formatUsdCompact(Number(v)) },
      ]}
    />
  );
}
